<template>
  <el-dialog
    :title="`Apply to: ${investor.name}`"
    :visible.sync="visible"
    :close-on-click-modal="false"
  >
    <el-select
      v-model="startupId"
      style="width: 100%;"
      placeholder="Select startup"
      default-first-option
      filterable
      remote
      :remote-method="onStartupsSearch"
      :loading="isStartupsFetchInProgress"
      @change="onStartupIdSelected"
    >
      <el-option
        v-for="startup in startupChoices"
        :key="startup.id"
        :value="startup.id"
        :label="startup.name"
      />
    </el-select>

    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Cancel</el-button>
      <el-button
        type="primary"
        :disabled="!startupId"
        :loading="processing"
        @click="onConfirm"
        >Confirm</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import http from 'services/http'
import storage from 'services/storage'
import _ from 'lodash'

const STORAGE_KEY = 'APPLY_AS_STARTUP_DIALOG_STARTUP_ID'

export default {
  data() {
    return {
      visible: false,
      processing: false,
      investor: {
        id: null,
        name: '',
      },
      startupId: null,
      startupChoices: [],
      isStartupsFetchInProgress: false,
    }
  },
  methods: {
    async onConfirm() {
      this.processing = true
      const startupId = this.startupId
      const investorId = this.investor.id
      try {
        const url = `/startups/${startupId}/classify-investor`
        const response = await http.postAuthed(url, {
          investor_id: investorId,
          state: 'applied',
        })
        this.$emit('applied', { startupId, investorId })
        this.visible = false
      } finally {
        this.processing = false
      }
    },
    onStartupsSearch(name) {
      this.debouncedFetchStartups(name)
    },
    debouncedFetchStartups: _.debounce(function (name) {
      this.fetchStartups(name)
    }, 200),
    async fetchStartups(name) {
      this.isStartupsFetchInProgress = true
      const url = `/startups`
      const params = { search: name }
      try {
        const response = await http.getAuthed(url, params)
        this.startupChoices = response.data.results
      } finally {
        this.isStartupsFetchInProgress = false
      }
    },
    onStartupIdSelected(startupId) {
      const startup = this.startupChoices.filter((s) => s.id === startupId)[0]
      storage.set(STORAGE_KEY, startup)
    },
    open(investor) {
      this.visible = true
      this.investor = investor
      const startup = storage.get(STORAGE_KEY)
      if (startup) {
        this.fetchStartups(startup.name)
        this.startupId = startup.id
      }
    },
    focusInput() {
      this.$nextTick(() => {
        this.$el.querySelector('input').focus()
      })
    },
  },
}
</script>
